'use strict';

const FOCUSABLE = 'button:not(:disabled):not([aria-hidden="true"]),a[href]';

module.exports = class Modal {
    constructor (element, config, custom={}) {
        this.modal = element;
        this._onKeyDown = this._onKeyDownFn.bind(this);
        this._open = false;
        this._previouslyFocussedElement = null;
        this._config = Object.assign({ onShow: null, onClose: null }, config);
        this.custom = custom;
    }

    _trapFocus (event) {
        let focusableNodes = $(this.modal).find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
        const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
        if (event.shiftKey && focusedItemIndex === 0) {
            focusableNodes[focusableNodes.length - 1].focus();
            event.preventDefault();
        }
        if (!event.shiftKey && focusableNodes.length > 0 && focusedItemIndex === focusableNodes.length - 1) {
            focusableNodes[0].focus();
            event.preventDefault();
        }
    };

    _onKeyDownFn(event) {
        if (event.keyCode === 27) { // ESC
            this.close();
        } else if (event.keyCode === 9) { // TAB
            this._trapFocus(event);
        }
    };

    _registerEvents() {
        const closeEvt = (e) => {
            e.stopPropagation();
            this.close();
        };
        $(this.modal).one('click', '.js-close', closeEvt.bind(this));
        document.addEventListener('keydown', this._onKeyDown);
    }

    open() {
        this._previouslyFocussedElement = document.activeElement;
        let $modal = $(this.modal);
        $('body').addClass('cc-blocked');
        $modal.removeClass('hidden').attr('aria-hidden', 'false');
        const focusFirstElementInModal = () => {
            let focusableNodes = $modal.find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
            focusableNodes[0].focus();
        };

        this._registerEvents();
        // We add the class in another frame in order to have the animation
        let t = this;
        setTimeout(function() {
            $modal.addClass('cc-open');
            focusFirstElementInModal();
            if (t._config.onShow) {
                t._config.onShow.apply(null, t.arguments);
            }
        }, 0);

        this._open = true;
    }

    close() {
        if (!this._open) {
            return;
        }
        if (this._previouslyFocussedElement) {
            let $modal = $(this.modal);
            $modal.removeClass('cc-open');
            $modal.one('transitionend', () => {
                if (! $modal.hasClass('cc-open')) {
                    $modal.addClass('hidden').attr('aria-hidden', 'true');
                    this._open = false;
                    if (! $(this._previouslyFocussedElement).is('iframe')) {
                        this._previouslyFocussedElement.focus();
                    }
                }
            });
            if (this._config.onClose) {
                this._config.onClose.apply(null, arguments);
            }
            $('body').removeClass('cc-blocked');
            document.removeEventListener('keydown', this._onKeyDown);
        }
    }

    isOpen() {
        return this._open;
    }
};
